import axios from "axios";
import { useEffect, useState } from "react";

const useUserById = (id) => {
    const [userq, setUserq] = useState({});
    useEffect(() => {
        axios.get(`https://tripaide-server.onrender.com/u/${id}`)
            .then(res => {
                setUserq(res.data);
                //console.log(res.data);
            })
    }, [id]);
    return [userq, setUserq]
};

export default useUserById;